import { isIOS, isMobile} from "./isMobile";

export const getCTAMetric = (type: string) => {
  const isIOsDevice = isIOS();
  const metric = {
    'signup': 'signupnow',
    'call': 'callnow',
    'donate': 'donatenow',
    'email': 'email-modal-mailto-link',
    'app': isIOsDevice ? 'ios-app-download' : 'android-app-download' ,
    'get-app':  isIOsDevice || isMobile() ? 'ios-app-download' : 'android-app-download',
    'join-meeting': 'joinmeeting',
    'order': 'ordernow',
    'register': 'registernow' ,
    'rsvp': 'rsvpnow' ,
    'subscribe': 'subscribenow' ,
    'survey': 'surveynow' ,
    'download': 'downloadnow',
    'learn-more': 'learnmore'
  }[type];

 return metric;
}
